package app.nestbridge.feature.careteam.api

import app.nestbridge.app.di.ClientApiConfig
import app.nestbridge.feature.careteam.api.model.CareTeamDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.HttpStatusCode
import io.ktor.http.isSuccess
import io.ktor.http.contentType
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class RemoteCareTeamApiClient(
    private val httpClient: HttpClient,
    private val config: ClientApiConfig,
) : CareTeamApiClient {

    private val baseUrl get() = "${config.childServiceUrl}/care-teams"

    override suspend fun fetch(id: String): CareTeamDto? {
        val response: HttpResponse = httpClient.get("$baseUrl/$id")
        return when (response.status) {
            HttpStatusCode.OK -> response.body()
            HttpStatusCode.NotFound -> null
            else -> error("Unexpected response fetching care team '$id': ${response.status}")
        }
    }

    override suspend fun fetchAll(): List<CareTeamDto> {
        val response = httpClient.get(baseUrl)
        if (!response.status.isSuccess()) {
            error("Failed to fetch care teams (${response.status}): ${response.bodyAsText()}")
        }
        return response.body()
    }

    override suspend fun fetchByChildId(childId: String): List<CareTeamDto> {
        val response = httpClient.get("$baseUrl/by-child/$childId")
        if (!response.status.isSuccess()) {
            error("Failed to fetch care teams for child '$childId' (${response.status}): ${response.bodyAsText()}")
        }
        return response.body()
    }

    override suspend fun save(careTeam: CareTeamDto): CareTeamDto {
        val response = if (careTeam.id.isBlank()) {
            httpClient.post(baseUrl) {
                contentType(ContentType.Application.Json)
                setBody(careTeam)
            }
        } else {
            httpClient.put("$baseUrl/${careTeam.id}") {
                contentType(ContentType.Application.Json)
                setBody(careTeam)
            }
        }
        if (!response.status.isSuccess()) {
            error("Failed to save care team (${response.status}): ${response.bodyAsText()}")
        }
        return response.body()
    }
}
